<template>
    <v-dialog
        v-model="innerValue"
        v-bind="$attrs"
        max-width="350"
    >
        <v-card>
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Share to social
                </v-toolbar-title>
            </v-toolbar>

            <v-card-actions class="justify-space-around py-10">
                <ShareNetwork
                    network="facebook"
                    :url="referralLink"
                    :title="sharedText"
                    :quote="sharedText"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small primary"
                >
                    <v-icon color="white">
                        mdi-facebook
                    </v-icon>
                </ShareNetwork>

                <ShareNetwork
                    network="messenger"
                    :url="referralLink"
                    :title="sharedText"
                    :quote="sharedText"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small blue"
                >
                    <v-icon color="white">
                        mdi-facebook-messenger
                    </v-icon>
                </ShareNetwork>

                <ShareNetwork
                    network="whatsapp"
                    :url="referralLink"
                    :title="sharedText"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small green accent-3"
                >
                    <v-icon color="white">
                        mdi-whatsapp
                    </v-icon>
                </ShareNetwork>

                <ShareNetwork
                    network="telegram"
                    :url="referralLink"
                    :title="sharedText"
                    class="v-btn v-btn--contained v-btn--fab v-btn--round theme--light v-size--small light-blue darken-2"
                >
                    <v-icon color="white">
                        mdi-telegram
                    </v-icon>
                </ShareNetwork>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data: () => ({
            loading: false,
            referralCode: '',
            sharedText: `Hi!
                I've been using a secure and affordable peer-to-peer platform called Kaoshi to fulfill my money transfer obligations.
                Here are some of the great things you can do on Kaoshi:
                - Send Naira to Nigeria from over 40 countries worldwide
                - Send money internationally, from Nigeria
                - Request money or payment internationally, from Nigeria
                - Swap your Naira for inflow US Dollars, directly into your domiciliary account
                All from the comfort of wherever you are.
                Join the Network today by tapping the link below.`,
        }),
        computed: {
            innerValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
            referralLink() {
                const route = this.$router.resolve({
                    name: 'referral-page',
                    params: {
                        referralCode: this.$_user.referral_code,
                    },
                });
                return `${window.location.origin}${route.href}`;
            },
        },
        mounted() {
            this.referralCode = this.$_user.referral_code || '';
        },
        methods: {
            async updateReferralCode() {
                try {
                    this.loading = true;

                    const payload = {
                        referral_code: this.referralCode,
                    };

                    const { data } = await Vue.backendApi()
                        .user(this.$store.state.user.id)
                        .storeUser(payload);

                    this.$store.commit('storeUser', data);

                    this.$swal({
                        type: 'success',
                        title: 'Referral code successfully updated!',
                    });
                } catch (error) {
                    this.errors.add({
                        field: 'referralCode',
                        msg: error,
                    });

                    this.$validator.flag('referralCode', {
                        changed: false,
                    });
                } finally {
                    this.loading = false;
                }
            },

            /**
             * Remove all errors when value changed
             * for the first time after trying to save
             */
            updateValidationErrors() {
                if (!this.fields.referralCode.changed) {
                    this.errors.remove('referralCode');
                }
            },
        },
    };
</script>
